import React, { useState, useEffect } from 'react';
import './ItRequestAdminSingleView.css';
import LoadingComp from '../common/loading.js';
import { ApiError } from '../common/apiError.js';
import { SEC_ApiCall } from '../func.js';
import { RequestToolbar } from '../common/toolbar/RequestToolbar.js';
import { MarkRequestComplete } from '../common/toolbar/MarkRequestComplete.js';
import { MarkRequestIncomplete } from '../common/toolbar/MarkRequestIncomplete.js';
import { Return } from '../common/toolbar/Return.js';
import { AddNote } from '../common/toolbar/AddNote.js';
import { RequestOpen, RequestComplete } from '../common/RequestStatusComponents.js';
import { NoteInputComponent } from '../common/toolbar/NoteInputComponent.js';


export default function ItUserSrv() {
  // data and page loading states
  const [dataState, setDataState] = useState([]);
  const [requestIdState, setRequestIdState] = useState(null);
  const [isLoadedState, setIsLoadedState] = useState(false);
  const [apiErrorState, setApiErrorState] = useState(false);
  const [apiErrorDataState, setApiErrorDataState] = useState('');

  const [requestStatusState, setRequestStatusState] = useState(false);

  async function apiCall(id) {
    var url = 'it-requests/user/single?requestId=' + id;
    var params = {};
    try {
      const response = await SEC_ApiCall(url, params, setApiErrorState);
      const jsonObj = JSON.parse(response);
      setDataState(jsonObj['data']);
      if (jsonObj['data']["completed"] == 0) {
        setRequestStatusState(false);
      }
      else {
        setRequestStatusState(true);
      }
      setIsLoadedState(true);
    } catch (e) {
      console.log(e);
      setIsLoadedState(true);
      setApiErrorState(true);
      setApiErrorDataState(e);
    }
  };

  useEffect(() => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const id = params.get('id');
    setRequestIdState(id);
    if (id) {
      apiCall(id);
    } else {
      setIsLoadedState(true);
      setApiErrorState(true);
    }

  }, []);

  if (!isLoadedState) {
    return (
      <div className='main_div'>
        <LoadingComp />
      </div>
    )
  } else if (apiErrorState) {
    return (
      <ApiError />
    )
  } else {

    return (
      <div className='internal_main_div'>
        <div className="request-container">
          <RequestToolbar
            leftButtons={<Return onClick={() => console.log("Return to table")} />}
            rightButtons={[
              requestStatusState ? (
                <MarkRequestIncomplete
                  url="it-requests/single-it-request/incomplete"
                  id={dataState.requestId}
                  updateApiCallFunction={apiCall}
                  key="mark-incomplete"
                />
              ) : (
                <MarkRequestComplete
                  url="it-requests/single-it-request/complete"
                  id={dataState.requestId}
                  updateApiCallFunction={apiCall}
                  key="mark-complete"
                />
              ),
              <AddNote
                key="add-note"
                optionsComponent={
                  <NoteInputComponent
                    requestId={dataState.requestId}
                    url="it-requests/single-it-request/notes" // Example for IT requests
                    updateApiCallFunction={apiCall}
                  />
                }
              />
            ]}

          />
          <h2>IT Support Request Details - {dataState.requestId}</h2>
          {requestStatusState ? <RequestComplete /> : <RequestOpen />}
          <div className='request-container-internal'>
            <div className="request-info">
              <p><strong>Title:</strong> {dataState.requestTitle}</p>
              <p><strong>Description:</strong> {dataState.requestEvents.primaryEvent.eventData}</p>
              <p><strong>Location:</strong> {dataState.requestLocation}</p>
              <p><strong>Submitted On:</strong> {new Date(dataState.submissionTimestamp).toLocaleString("en-GB")}</p>
              {dataState.assignedUser !== "None" && (
                <p><strong>Assigned To:</strong> {dataState.assignedUser}</p>
              )}
              <p><strong>Required Date:</strong> {new Date(dataState.requiredDate).toLocaleDateString("en-GB")}</p>
            </div>


            <div className="request-events">
              <h3>Notes</h3>
              {dataState.requestEvents.additionalEvents.length > 0 && (
                <div className="additional-events">
                  {dataState.requestEvents.additionalEvents.map((event, index) => (
                    <div key={index} className="event">
                      <div className='event-user-timestamp'>
                        <p>{event.user}</p>
                        <p>{new Date(event.timestamp).toLocaleString("en-GB")}</p>
                      </div>
                      <p>{event.eventData}</p>


                    </div>
                  ))}
                </div>
              )}
            </div>

          </div>
        </div>




      </div >
    )
  }
};
